var map = {
	"./_MG_4858.jpg": 91851,
	"./_MG_4865.jpg": 72201,
	"./_MG_4875.jpg": 89848,
	"./_MG_4977.jpg": 86330
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85955;
module.exports = webpackAsyncContext;